import Vue from 'vue';

import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)

import imgPopButton from '@/components/common/imgPopButton.vue'
Vue.component('imgPopButton', imgPopButton)